import { isExcludeProductSelection, ProductSelection } from './ProductSelectionTypes';

export const getProductSelectionCount = (state: ProductSelection): number => {
    return isExcludeProductSelection(state) ? state.totalCount - state.excluded.length : state?.included.length ?? 0;
};

export const hasProductSelection = (state: ProductSelection) => !!state;
